// extracted by mini-css-extract-plugin
export default {"container":"BooksAndRecordsNav_container__d4sMg","nav":"BooksAndRecordsNav_nav__PtcBk","nav-btn":"BooksAndRecordsNav_nav-btn__Rrc2i","active":"BooksAndRecordsNav_active__iFKvN"};